import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS_ENTITY } from '../constants/apiUrl';
import { ISystemInfoResponseDto } from '../interface/system';

interface IUseFetchSystemInfoOptions {
  enabled?: boolean;
}

export const useFetchSystemInfo = (options?: IUseFetchSystemInfoOptions) => {
  const url = `${API_URLS_ENTITY.SYSTEM}${API_URLS_ENTITY.INFO}`;
  const query = useQuery<ISystemInfoResponseDto, Error>({
    queryKey: ['system-info'],
    queryFn: () => {
      return get(url);
    },
    enabled: options?.enabled,
  });

  return query;
};
